module.exports = __webpack_public_path__ + "assets/img/btn-download-steam-657f01ab.png";